<section class="padding-60px-tb testimonial-style7 bg-gray xs-padding-60px-tb" id="services">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12 col-sm-12 col-12 text-center">
                <h2
                    class="section-title-large sm-section-title-medium xs-section-title-large text-servios font-weight-600 alt-font margin-three-bottom xs-margin-fifteen-bottom">
                    Nuestros servicios</h2>
                <!--   <div
                    class="text-medium width-60 margin-lr-auto md-width-70 sm-width-100 margin-seven-bottom xs-margin-nineteen-bottom">
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                    industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                    and scrambled it to make a type specimen book.</div> -->
            </div>
            <!-- end section title -->
        </div>
        <div class="row justify-content-center">

            <div *ngFor="let item of lista"
                class="col-md-4 col-sm-6 col-12 xs-text-center xs-margin-nine-bottom wow animated slideInUp padding-bottom-10px">
                <div class="testimonial-box bg-white pull-left width-100 text-center" style="min-height: 354px;">
                    <div class="icon-extra-large text-red margin-thirteen-bottom margin-six-top">
                        <i [class]="item.icon"></i>
                    </div>
                    <span
                        class="alt-font font-weight-700 margin-thirteen-bottom text-dark-gray margin-two-top sm-text-medium display-block">
                        {{item.nombre | uppercase}} </span>
                    <div class="text-medium text-light-gray2">
                        <p> {{item.descripcion}}</p>
                    </div>
                    <a [routerLink]="['/servicio', item.id]" class="text-red"><span>VER
                            MÁS</span></a>
                </div>
            </div>






        </div>
    </div>
</section>